const zhCN = {
  pageErrTitle: '页面错误',
  pageErrContent: '信息错误，请返回人员管理列表！',
  backBtn: '返回',

  creationTime: '人员创建时间：',
  expiryDateTitle: '授权有效期',

  expiryDateTxt: '有效期',
  dateStartTxt: '开始时间',
  dateEndTxt: '结束时间',
  comingWeekBtn: '未来一周',
  comingMonthBtn: '未来一个月',
  comingHalfYearBtn: '未来半年',
  comingYearBtn: '未来一年',

  permanentTxt: '永久授权',

  expiryDateBlank: '请选择授权有效时间段，或选择永久授权！',
  expiryDateWarning: '授权时间段最多为一年，或选择永久授权！',

  saveBtn: '保存',
  editExpiryDateSuccess: '修改授权有效期成功！',
  editExpiryDateFail: '修改设备有效期失败！',

  authDeviceTitle: '授权设备',
  authedDeiveCountTips: '已授权设备',
  authedDeiveCount: 'return "共 " + count + " 台"',

  listAuthedDeviceSN: '设备SN',
  listAuthedDeviceName: '设备名称',
  listAuthedDeviceOrg: '所属',
  listAuthedDeviceOperation: '操作',
  listRemoveAuthedDeviceBtn: '移除',
  requestAuthedDeviceFail: '获取已授权设备失败！',

  removing: '正在移除授权设备中...',

  searchOrgTxt: '所属机构',
  searchDeviceStatus: '设备状态',
  searchDeviceStatusAllOption: '全部',
  searchDeviceSNOrName: '设备SN/设备名称',
  searchBtn: '搜索',

  listDeviceSN: '设备SN',
  listDeviceName: '设备名称',
  listDeviceStatus: '状态',
  listDeviceOrg: '所属',
  listDeviceOperation: '操作',
  listAddDeviceBtn: '授权',
  requestDeviceFail: '获取设备信息失败！',

  addWarning: '该设备已经授权！',
  addWarningDesc: '请选择其他设备进行授权。',
  adding: '正在添加授权设备中...',

  editAuthorizedSuccess: '修改授权设备成功！',
  editAuthorizedFail: '修改授权设备失败！'
}
const enUS = {
  pageErrTitle: 'Page Error',
  pageErrContent: 'Page error, please return to the personal management list!',
  backBtn: 'Back',

  creationTime: 'Creation Time: ',
  expiryDateTitle: 'Set Expiry Date',

  expiryDateTxt: 'Expiry Date',
  dateStartTxt: 'start',
  dateEndTxt: 'end',
  comingWeekBtn: 'coming week',
  comingMonthBtn: 'next 30 days',
  comingHalfYearBtn: 'next 6 months',
  comingYearBtn: 'a future year',

  permanentTxt: 'Permanent',

  expiryDateBlank: 'Expiry date can\'t be blank, or choose permanent!',
  expiryDateWarning: 'Expiry date is up to a year，or choose permanent!',

  saveBtn: 'Save',
  editExpiryDateSuccess: 'Edit expiry date successfully!',
  editExpiryDateFail: 'Edit expiry date failed!',

  authDeviceTitle: 'Authorize Devices',
  authedDeiveCountTips: 'Authorized',
  authedDeiveCount: 'return count + " Set"',

  listAuthedDeviceSN: 'SN',
  listAuthedDeviceName: 'Name',
  listAuthedDeviceOrg: 'Organization',
  listAuthedDeviceOperation: 'Operation',
  listRemoveAuthedDeviceBtn: 'Remove',
  requestAuthedDeviceFail: 'Request authorized devices failed!',

  removing: 'Removing the authorized device...',

  searchOrgTxt: 'Organization',
  searchDeviceStatus: 'Status',
  searchDeviceStatusAllOption: 'All',
  searchDeviceSNOrName: 'SN/Name',
  searchBtn: 'Search',

  listDeviceSN: 'SN',
  listDeviceName: 'Name',
  listDeviceStatus: 'Status',
  listDeviceOrg: 'Organization',
  listDeviceOperation: 'Operation',
  listAddDeviceBtn: 'Authorize',
  requestDeviceFail: 'Request devices failed!',

  addWarning: 'This device has been authorized!',
  addWarningDesc: 'Please select another device for authorization.',
  adding: 'Adding an authorized device...',

  editAuthorizedSuccess: 'Edit authorized device successfully!',
  editAuthorizedFail: 'Edit authorized device failed!'
}

export default { zhCN, enUS }